'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import ExportReportButtonContainer from 'AdsUI/containers/ExportReportButtonContainer';
const FilterContainer = styled.div.withConfig({
  displayName: "FilterBarWithExport__FilterContainer",
  componentId: "abjknn-0"
})(["line-height:2.5em;vertical-align:baseline;"]);

const FilterBarWithExport = ({
  entityType,
  loaded,
  children
}) => /*#__PURE__*/_jsxs("div", {
  className: "flex-no-wrap justify-between align-center m-bottom-4",
  children: [/*#__PURE__*/_jsx(FilterContainer, {
    children: children
  }), /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(ExportReportButtonContainer, {
      entityType: entityType,
      loaded: loaded
    })
  })]
});

export default FilterBarWithExport;